import { FC } from 'react'
import s from './ListingDescriptionPage.module.sass'
import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import { useAppSelector } from '@app/model/store/client'
import { ListingDescriptionPageSkeleton } from '@pages/Listing/ui/ListingDescriptionPage/index'
import type { ListingSeoIntro } from '@pages/Listing/model/types'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { DiscloseText } from '@shared/ui/Actions/DiscloseText'

type Props = {
  // SEO-текст с SSR — виден в HTML до hydration
  seoIntro?: ListingSeoIntro | null
}

const ListingDescriptionPage: FC<Props> = ({ seoIntro }) => {
  const { title, description } = useAppSelector((store) => store.pages.listing)

  const resolvedTitle = title ?? seoIntro?.title ?? null
  const resolvedDescription = description ?? seoIntro?.description ?? null

  if (!resolvedTitle && !resolvedDescription) return <ListingDescriptionPageSkeleton />

  return (
    <BlockBoundary>
      {resolvedTitle && (
        <Title className={s['main-title']} tag='h1' sizes='h1'>
          {resolvedTitle}
        </Title>
      )}

      {resolvedDescription && (
        <DiscloseText
          microButton={true}
          textModeExpandLabel='Развернуть'
          cssCollapsedMaxHeight={true}
          contentClassName={s['description-content']}
          className={s['description-wrapper']}>
          <Text sizes='M' className={s['main-description']} tag='p'>
            {resolvedDescription}
          </Text>
        </DiscloseText>
      )}
    </BlockBoundary>
  )
}

export default ListingDescriptionPage
